import axios from "axios";
import { Loading, Notification } from "element-ui";
// import Vue from 'vue'
import global_ from "../views/Global";

let mobileApiHost = process.env.MOBILE_API_HOST;
let newApiHost = process.env.NEW_API_HOST;

// new Vue().GLOBAl.localSrc

let localSrc = global_.localSrc;
// let _this = new Vue();

// 加载层控制
let loading = {
  loading: null,
  open: function() {
    this.loading = Loading.service({
      lock: true,
      text: "拼命加载中，请稍后",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
  },
  close: function() {
    this.loading.close();
  }
};

// Http请求拦截器：设置Headers(添加身份校验参数)
axios.interceptors.request.use(config => {
  // 打开加载层
  loading.open();
  // 设置headers
  if (config.url.indexOf("login") === -1) {
    let login = window.localStorage.getItem("login");
    if (login) {
      login = JSON.parse(login);
      config.headers["X-TOKEN"] = login.token;
      config.headers["X-CONTEXT"] = "b35a9c87-f52a-4a80-9217-2b1a30083008";
    }
  }
  return config;
});

// Http请求响应拦截器：统一处理异常情况
axios.interceptors.response.use(
  response => {
    // 关闭加载层
    loading.close();
    // 错误提示
    // if (response.data.code != 200) {
    //   Notification.error({
    //     title: '错误提示',
    //     message: response.data.message,
    //     duration: 2000
    //   });
    // }
    return response;
  },
  error => {
    // 关闭加载层
    loading.close();
    // 弹出错误提示
    Notification.error({
      title: "错误提示",
      message: "网络错误请稍后重试",
      duration: 2000
    });
    return Promise.reject(error);
  }
);

// API访问地址
let api_host = process.env.API_HOST;

// console.log('api_host:' + api_host);
// let api_dev = process.env.API_DEV;
// console.log('api_dev:' + process.env.API_DEV);

// let api_test = process.env.API_TEST;

/**
 * 发送post请求
 * @param url
 * @param params
 * @returns {*}
 */
export const request_post = (url, params) => {
  return axios.post(`${api_host}${url}`, params).then(res => res.data);
};

/**
 * 发送get请求
 * @param url
 * @param params
 * @returns {*}
 */
export const request_get = (url, params) => {
  return axios
    .get(`${api_host}` + url, {
      params: params
    })
    .then(res => res.data);
};

/**
 * 发送get请求
 * @param url
 * @param params
 * @returns {*}
 */

export const redirt_get_new = (url, params) => {
  return axios
    .get(`${newApiHost + url}?debug=false`, {
      params: params
    })
    .then(res => res.data);
};

/**
 * 发送post请求
 * @param url
 * @param params
 * @returns {*}
 */
export const redirt_post_new = (url, params) => {
  return axios
    .post(`${newApiHost + url}?debug=false`, params)
    .then(res => res.data);
};
// export const request_post = (url, params) => {
//   return axios.post(`${api_host}` + url, params).then(res => res.data)
// };


/**
 * 发送post请求
 * @param url
 * @param params
 * @returns {*}
 */
export const redirt_delete_new = (url, params) => {
  return axios
    .delete(`${newApiHost + url}?debug=false`, {
      params: params
    })
    .then(res => res.data);
};
/**
 * 发送post请求
 * @param url
 * @param params
 * @returns {*}
 */
export const redirt_put_new = (url, params) => {
  return axios
    .put(`${newApiHost}${url}?debug=false`, params)
    .then(res => res.data);
};


// 数据报表请求接口
/**
 * 发送get请求
 * @param url
 * @param params
 * @returns {*}
 */
export const datatb_get = (url, params) => {
  return axios
    .get(localSrc + url, {
      params: params
    })
    .then(res => res.data);
};

/**
 * 发送post请求
 * @param url
 * @param params
 * @returns {*}
 */
export const datatb_post_new = (url, params) => {
  return axios.post(`${newApiHost}${url}`, params).then(res => res.data);
};
//导出模板
export const fileDownloadNewPost = (url, params) => {
  return axios
    .post(`${newApiHost}${url}`, params, {
      responseType: "blob"
    })
    .then(res => res.data);
};
export const downExcel = (url, params) => {
  return axios
    .get(`https://apphr.i.sinotrans.com/template${url}`, params, {
      responseType: "blob"
    })
    .then(res => res.data);
};

export const upNewExcel = (url, params) => {
  return axios.post(`${newApiHost}${url}`, params).then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/api/api.js